import { useParams } from 'react-router-dom';
import { RJSFPlayground } from './components/RJSFPlayground';

export default function PlaygroundPage() {
  const { id } = useParams<{ id: string }>();

  return <RJSFPlayground storeId={id} />;
}
